import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "antd";
import { Input } from "@vds/inputs";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Tooltip } from "@vds/tooltips";
import { Body, Title } from "@vds/typography";
import CircleIIcon from "../../../../../assets/circle_i.svg";
import ATSToolTip from "../../../../../global/components/ATSToolTip";
import { updateUI } from "../../../../../store/actions/deviceProfile";

function NonShipBleLoc() {
  const dispatch = useDispatch();
  const { formFields, alertGroupOptions,locationList } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
    alertGroupOptions: state.deviceProfile.ui.form.alertGroups,
    locationList: state.deviceProfile.data.locationList,
  }));
  const [isInView, setIsInView] = useState({
    trigger: false,
    gatalertgroup: false,
    gatlocgroup: false,
    bleassettype: false,
  });
  const location=locationList;
  const zoneoutput = [];

  // location?.forEach(loc => {
  //   const locName = loc.name;
  //   if (loc.floors) {
  //     Object.values(loc.floors).forEach(floor => {
  //       const floorId = floor.id;
  //       const floorName = floor.name;
  //     if (floor.zones) {
  //         Object.values(floor.zones).forEach(zone => {
  //           zoneoutput.push({
  //             locationName: locName,
  //             floorId: floorId,
  //             floorName: floorName,
  //             zoneId: zone.id,
  //             zoneName: zone.zone_name
  //           });
  //         });
  //       }
  //     });
  //   }
  // });

  const zoneMap = new Map();
  location?.forEach(loc => {
  const locName = loc.name;
  if (loc.floors) {
    Object.values(loc.floors).forEach(floor => {
      const floorId = floor.id;
      const floorName = floor.name;
      if (floor.zones) {
        Object.values(floor.zones).forEach(zone => {
          if (!zoneMap.has(zone.id)) {
            zoneMap.set(zone.id, {
              locationName: locName,
              floorId,
              floorName,
              zoneId: zone.id,
              zoneName: zone.zone_name
            });
          }
        });
      }
    });
  }
});

  const options = Array.from(zoneMap.values()).map((item) => ({
  value: item.zoneId,
  label: `${item.locationName} - ${item.floorName} - ${item.zoneName}`,
}));

  // const options = zoneoutput?.map((item) => ({
  //   value: item.zoneId,
  //   label: `${item.locationName} - ${item.floorName} - ${item.zoneName}`,
  // }));
  const handleFormField = (stateField, field, value, error = "") => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            nonshipstep3: {
              ...formFields.nonshipstep3,
              [stateField]: {
                ...formFields.nonshipstep3[stateField],
                [field]: { value, isValid: true },
              },
            },
          },
        },
      })
    );
  };

  return (
    <>
      <ModalBody>
         <div className="d-flex flex-column justify-content-start align-items-start mb-4">
          <div className="d-flex flex-row align-items-center">
            <Body size="small">Location zone</Body>
              <Tooltip
                  title=""
                  size="medium"
                  surface="light"
                >
                 You can select up to 5 location zones.
                </Tooltip>
            </div>
            <Select
            className={`shipment-form-fields-alertGroup ${formFields?.nonshipstep3?.nonshipbleloc?.locationzone?.class}`}
            key={"[stateSelectorIndex]-alert-group"}
            maxTagCount={5} 
            placeholder="None"
            mode="multiple"
            showSearch 
            optionFilterProp="label"  
            allowClear
            labelInValue
            value={formFields?.nonshipstep3?.nonshipbleloc?.locationzone?.value || []}
            onChange={(val) => {
            if (val.length > 5) {
              return; 
            }
            handleFormField("nonshipbleloc", "locationzone", val);
          }}
           // onChange={(val) => handleFormField("nonshipbleloc", "locationzone", val)}
            style={
              formFields?.nonshipstep3?.nonshipbleloc?.locationzone?.value
                ?.length > 0
                ? {
                    width: "100%",
                    minHeight: "44px !important",
                  }
                : {
                    width: "100%",
                    minHeight: "44px !important",
                  }
            }
            options={options}
          />
           <span className="zone-label" size="small">Name format : Location name - floor name - zone name</span>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
            <div className="w-100 d-flex flex-row">
            <div className="w-50 pe-2">
               <Body size="small">Trigger alerts on</Body>
              <Select
                className={`shipment-form-fields ${formFields?.nonshipstep3?.nonshipbleloc?.trigger?.class}`}
                value={formFields?.nonshipstep3.nonshipbleloc?.trigger?.value || []}
                onChange={(val) => handleFormField("nonshipbleloc", "trigger", val)}
                style={{ width: "100%" }}
                options={[
                  { value: "entry and exit", label: "Both (Entry and exit)" },
                  { value: "entry only", label: "Entry only" },
                  { value: "exit only", label: "Exit only" },
                ]}
              />
            </div>
            <div className="w-50">
              <div className="d-flex flex-row align-items-center">
               <Body size="small">Alert type</Body>
                <Tooltip
                  title=""
                  size="medium"
                  surface="light"
                >
                  Severity level of the alarm
                </Tooltip>
                </div>
               <Input
              className={`shipment-form-fields`}
              value={"Notification"}
              readOnly={true}
            />
            </div>
          </div>
        </div>
        <div className="d-flex flex-column justify-content-start align-items-start mb-4">
          <div className="d-flex flex-row justify-content-start align-items-center gap-1">
            <div className="d-flex flex-row align-items-center">
            <Body size="small">Alert group</Body>
              <Tooltip
                  title=""
                  size="medium"
                  surface="light"
                >
                 Alert groups to be notified of the alarm
                </Tooltip>
                </div>
          </div>
         <Select
              mode="multiple"
              className={`shipment-form-fields-alertGroup ${formFields?.nonshipstep3?.nonshipbleloc?.alertGroup?.class}`}
              allowClear
              value={formFields?.nonshipstep3.nonshipbleloc?.alertgroup?.value}
              onChange={(val) => handleFormField("nonshipbleloc", "alertgroup", val)}
              options={alertGroupOptions}
               style={
                formFields?.nonshipstep3.nonshipbleloc?.alertgroup?.value?.length > 0
                  ? {
                      width: "100%",
                    }
                  : {
                      width: "100%",
                      height: "44px",
                    }
              }
            />
        </div>
      </ModalBody>
    </>
  );
}

export default NonShipBleLoc;